var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import translations from '../core/translations';
export var humanReadable = function (elapsedSeconds, language) {
    var translation = __assign({}, translations[language]);
    var dateformats = translation.dateformats;
    var output = "";
    if (elapsedSeconds < 60) {
        // Less than a minute has passed:
        var seconds = Math.floor(elapsedSeconds);
        output = "".concat(seconds, " ").concat(dateformats.seconds(seconds), " ").concat(dateformats.ago);
    }
    else if (elapsedSeconds < 3600) {
        // Less than an hour has passed:
        var minutes = Math.floor(elapsedSeconds / 60);
        output = "".concat(minutes, " ").concat(dateformats.minutes(minutes), " ").concat(dateformats.ago);
    }
    else if (elapsedSeconds < 86400) {
        // Less than a day has passed:
        var hours = Math.floor(elapsedSeconds / 3600);
        output = "".concat(hours, " ").concat(dateformats.hours(hours), " ").concat(dateformats.ago);
    }
    else if (elapsedSeconds < 2620800) {
        // Less than a month has passed:
        var days = Math.floor(elapsedSeconds / 86400);
        output = "".concat(days, " ").concat(dateformats.days(days), " ").concat(dateformats.ago);
    }
    else if (elapsedSeconds < 31449600) {
        // Less than a year has passed:
        var months = Math.floor(elapsedSeconds / 2620800);
        output = "".concat(months, " ").concat(dateformats.months(months), " ").concat(dateformats.ago);
    }
    else {
        // More than a year has passed:
        var years = Math.floor(elapsedSeconds / 31449600);
        output = "".concat(years, " ").concat(dateformats.years(years), " ").concat(dateformats.ago);
    }
    return output;
};
var processTimeAgo = function (passedTimestamp) {
    var milliSecondsTo = new Date().getTime();
    var milliSecondsPassed = new Date(passedTimestamp).getTime();
    var elapsedSeconds = (milliSecondsTo - milliSecondsPassed) / 1000; // in seconds
    var language = window._mensenlinqLang || 'en';
    return humanReadable(elapsedSeconds, language);
};
export default processTimeAgo;
